/**
* Accordion
*/

import $ from 'jquery';

// Cached elements
const $el = {
	toggleButton: $('.js-toggle-trigger'),
	toggleText: $('.js-toggle-trigger').text(),
	toggleTextSwap: $('.js-toggle-trigger').data('swap-text'),
	toggleContent: $('.js-toggle-content')
};


// Module events
export default function init() {
	bindEvents();
}

// User interactions go here
function bindEvents() {
	$el.toggleButton.on('click', doToggle); 
}

function doToggle(e) {
	e.preventDefault();
	
	const $this = $(this);	
		
	if ($el.toggleContent.is(':visible')) {
		$el.toggleContent.slideUp({
			easing: 'easeInOutQuart'
		});
		$this.text($el.toggleText);
		$this.removeClass('is-active');
		
	} else {
		$el.toggleContent.slideDown({
			easing: 'easeInOutQuart'
		});
		$this.text($el.toggleTextSwap);
		$this.addClass('is-active');
	}
}
